import React from 'react'
import { withTranslation } from 'react-i18next'
import Input from 'components/Input'
import LinkItem from 'components/Link'
import { FormBtn } from 'components/Btn'



export default withTranslation()(function LoginForm({ t, yupFields: { isDirty, isValid } }) {

  const fields = [
    {
      name: 'email',
      label: t('registration.field.email')
    },
    {
      name: 'password',
      label: t('registration.field.password'),
      type: 'password'
    }
  ]

  return (
    <div className="w-full mt-20 ">
      <label className="text-2xl mb-2 block font-bold">{t('registration.signin')}</label>

      <p className="inline-block mb-10 text-sm">
        {t('registration.register')}
        <LinkItem url="/register" tag={() => <span className="text-primary font-medium ml-2">
          {t('registration.signup')}
        </span>}
        />
      </p>


      {
        fields.map(field => {
          return (
            <div className="py-3" key={field.name}>
              <Input
                name={field.name}
                label={field.label}
                type={field?.type}
                labelwithin={true}
              />
            </div>
          )
        })
      }

      <div className="w-full py-5">
        <LinkItem
          url="/forgot-password"
          tag={() => <span className="text-primary font-medium">{t('registration.forgot')}</span>}
        />
      </div>

      <FormBtn
        content={'Login'}
        className="w-36 h-12 text-white rounded-xl bg-primary hover:bg-primary"
        disabled={!isValid || !isDirty}
      />

    </div>




    // <>
    //   {
    //     fields.map(field => {
    //       return (
    //         <div className="py-3" key={field.name}>
    //           <Input
    //             name={field.name}
    //             label={field.label}
    //             type={field?.type}
    //             labelwithin={true}
    //           />
    //         </div>
    //       )
    //     })
    //   }
    // </>
  )
})